import { Search } from "lucide-react";
import "./CustomerFilters.css";

function CustomerFilters({ filters, onChange }) {

    return (

        <div className="customer-filters">

            <div className="search-box">

                <Search size={18} />

                <input
                    type="text"
                    placeholder="Search customer..."
                    value={filters.search}
                    onChange={(e) =>
                        onChange("search", e.target.value)
                    }
                />

            </div>

            <select
                className="filter-select"
                value={filters.status}
                onChange={(e) =>
                    onChange("status", e.target.value)
                }
            >
                <option value="">All Status</option>
                <option value="active">🟢 Active</option>
                <option value="blocked">🔴 Blocked</option>
            </select>

            <input
                className="filter-input"
                type="text"
                placeholder="City"
                value={filters.city}
                onChange={(e) =>
                    onChange("city", e.target.value)
                }
            />

            <select
                className="filter-select"
                value={filters.sort}
                onChange={(e) =>
                    onChange("sort", e.target.value)
                }
            >
                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
                <option value="az">A - Z</option>
                <option value="za">Z - A</option>
            </select>

        </div>

    );

}

export default CustomerFilters;